import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import ToggleBase, { ToggleProps } from "@/components/ui/Form/Toggle/ToggleBase";

export interface SwitchControlledProps extends ToggleProps {
  control: Control;
}
const ToggleControlled: FC<SwitchControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <ToggleBase field={field} fieldState={fieldState} {...rest} />;
};
export default ToggleControlled;
